import React, { useEffect, useState } from "react";
import { ArtworkReference, ArtworkReferenceType } from "../../models/ArtworkReference";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid } from '@mui/material';
export default function ArtworkReferenceForm({
    initialValue,
    onSave,
    onCancel,
}: {
    initialValue: ArtworkReference;
    onSave: (ref: ArtworkReference) => void;
    onCancel: () => void;
}) {
    const [form, setForm] = useState<ArtworkReference>(initialValue);

    const change = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) =>
        setForm((f) => ({ ...f, [e.target.name]: e.target.value }));

    const handleSave = async () => {
        onSave(form);
    }

    return (
        <Grid container spacing={2}>
            <Grid size={{ xs: 12 }}>
            {/* Details */}
            <div>
                <label className="block text-sm font-medium">Reference Details</label>
                <textarea
                    name="details"
                    value={form.details}
                    onChange={change}
                    rows={4}
                    className="form-group"
                    required
                />
            </div>

            {/* Date Text */}
            <div>
                <label className="block text-sm font-medium">Date (optional)</label>
                <input
                    type="text"
                    name="dateText"
                    value={form.dateText ?? ""}
                    onChange={change}
                    placeholder="Year, date or date range"
                    className="form-group"
                />
            </div>

            {/* URL */}
            <div>
                <label className="block text-sm font-medium">URL (optional)</label>
                <input
                    type="url"
                    name="url"
                    value={form.url ?? ""}
                    onChange={change}
                    placeholder="https://example.com"
                    className="form-group"
                />
            </div>

            {/* Buttons */}
            <div className="flex justify-end gap-2">
                <button
                    type="button"
                    className="responsive-button"
                    onClick={handleSave}
                >

                    {form.artworkReferenceId ? 'Update' : 'Save' }
                </button>
            </div>
            </Grid>
        </Grid>
    );
}
